import { Cookies } from 'react-cookie';

import { AddHubToObjectRequest } from './types';

import axiosInterceptor from 'api/interceptor/axiosClient';

export const addHubToObject = async (info: { addData: AddHubToObjectRequest; slug: string }) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');

  const formData = new FormData();

  formData.append('hub', info.addData.hub);
  formData.append('sequence_number', String(info.addData.sequence_number));
  formData.append('installment_comment', info.addData.installment_comment);
  if (info.addData.installment_picture) {
    formData.append('installment_picture', info.addData.installment_picture as Blob);
  }

  const data = await axiosInterceptor.put(`/add_hub_to_object/${info.slug}`, formData, {
    headers: {
      Authorization: token,
      'Content-Type': 'multipart/form-data',
    },
  });

  return data.data as any;
};
